import React, { Fragment } from "react";
import {
  FormBlock,
  FormTitle,
  BlockFormMain,
  FormRow,
  HalfBlock,
  FormName,
  ActionForm,
} from "../../../generalStyles/mixin";
import InputComponent from "../../inputText";
import InputsComponent from "../../inputText-2";
import SelectComponent from "../../selectInput";
import Buttons from "../../button";
import {
  getFinishMaxDate,
} from "./../../utils/utils";
import * as env from "../../../environment";
import InputDateComponent from "../../inputDate";
import InputError from "../../inputError";
import ReactTable from "react-table";
import Pagination from "../../pagination/pagination";
import { TableTitle } from "../../pagination/styles";
import "react-table/react-table.css";
import "../../pagination/styles.css";
import Modal from "../../modal";
import Template from "../../modal/tempalte";
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../../login/aws-exports';
import { month_year, year } from '../../utils/constant';
import { validate, clean, format } from 'rut.js';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import { Link } from "react-router-dom";
import styled from "styled-components";
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import * as emailValidator from 'email-validator';

const { API_URL_BACKEND } = env[process.env.NODE_ENV];

Amplify.configure(awsconfig);

const WIDTH_CELL_BUSINESSID = 100;
const WIDTH_CELL_CREATE_AT = 180;
const WIDTH_CELL_ACTION = 120;
const WIDTH_CELL_CONTEXT_NAME = 250;
const WIDTH_CELL_STATUS_NAME = 200;

const BtnAction = styled.span`
  background: #f6f6f6;
  color: #292929;
  margin: 0px 2px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 10px 10px;
  cursor: pointer;
  &:hover {
    color: #070707;
    background-color: #f1f1f1;
  }
`;

class EstadoPagoComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      modalChildren: "",
      isClosable: false,
      text: '',
      image: '',
      token: localStorage.getItem("token"),
      data: [],
      rutUser: "",
      startDate: "",
      endDate: "",
      cuponPago: "",

      //manejo de errores
      //status
      sRutUser: false,
      sStartDate: false,
      sEndDate: false,
      sProcessId: false,

      //msj
      mRutUser: "",
      mStartDate: "",
      mEndDate: "",
      mProcessId: "",

      idOrder: "",
      engineId: "",
      visible: true,

      monthYear: month_year,
      yearSelect: [],

      selectMonth: '',
      selectYear: '',

      customDataDownload: [],
      open: false,
      textEmailTitular: '',
      textEmailCopies: '',
      sTextEmailTitular: false,
      mTextEmailTitular: '',
      stextEmailCopies: false,
      mtextEmailCopies: '',
      fullWidth: 'md',
      chipData: [],
      infoRow: {}
    };
  }

  async componentDidMount() {
    const years = await year();
    this.setState({ yearSelect: years });
  }

  handlerVisible = (visible) => {
    this.setState({
      visible: visible
    });
  }

  render() {
    if (localStorage.getItem('perfiles').includes('Sucursal')) {
      return (
        <Fragment>
          {this.state.visible ? (
            <form onSubmit={this.handleSubmit}>
              <FormBlock>
                <FormTitle>Consulta Estado Pago</FormTitle>
                <BlockFormMain>
                  <HalfBlock>
                    <FormRow>
                      <FormName>Rut</FormName>
                      <InputsComponent
                        onChange={this.onChangeRut}
                        value={this.state.rutUser}
                        onBlur={ this.onBlurRut }
                        name="rutUser"
                        ref="rutUser"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sRutUser}
                      value={this.state.mRutUser}
                    ></InputError>
                    <FormRow>
                      <FormName>Fecha de Inicio</FormName>
                      <InputDateComponent
                        onChange={this.onChangeStartDate}
                        ref="startDate"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sStartDate}
                      value={this.state.mStartDate}
                    ></InputError>
                    <FormRow>
                      <FormName>Cupon</FormName>
                      <InputComponent
                        onChange={this.onChangeCuponPago}
                        value={this.state.cuponPago}
                        name="cuponNumber"
                        ref="cuponNumber"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sOperationNumber}
                      value={this.state.mOperationNumber}
                    ></InputError>
                  </HalfBlock>
                  <HalfBlock>

                    <FormRow>
                      <FormName>Período de facturación</FormName>
                      <div style={{ display: 'flex', position: 'relative' }}>
                        <SelectComponent
                          style={{
                            control: (provided, state) => ({
                              ...provided,
                              borderRadius: 0,
                              cursor: 'pointer',
                              height: 50,
                              width: '185px',
                              borderColor: '#CCC',
                              marginRight: '12px'

                            }),

                            option: (provided, state) => ({
                              ...provided,
                              cursor: 'pointer',
                            }),
                          }}
                          placeholder="Mes"
                          options={this.state.monthYear}
                          onChange={this.onChangeBoxMonth}
                          ref="selectMonth"
                        />
                        <SelectComponent
                          style={{
                            control: (provided, state) => ({
                              ...provided,
                              borderRadius: 0,
                              cursor: 'pointer',
                              height: 50,
                              width: '185px',
                              borderColor: '#CCC'
                            }),

                            option: (provided, state) => ({
                              ...provided,
                              cursor: 'pointer',
                            }),
                          }}
                          placeholder="Año"
                          options={this.state.yearSelect}
                          onChange={this.onChangeBoxYear}
                          ref="selectYear"
                        />
                      </div>

                    </FormRow>
                    <InputError
                      isShow={this.state.sFlowsSelected}
                      value={this.state.mFlowsSelected}
                    ></InputError>

                    <FormRow>
                      <FormName>Fecha de Termino</FormName>
                      <InputDateComponent
                        onChange={this.onChangeEndDate}
                        ref="finishDate"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sEndDate}
                      value={this.state.mEndDate}
                    ></InputError>
                  </HalfBlock>
                </BlockFormMain>
                <ActionForm>
                  <Buttons.Primary>Buscar</Buttons.Primary>
                  <Buttons.Clear
                    type="none"
                    onClick={(e) => {
                      e.preventDefault();

                      this.setState({ startDate: "" });
                      this.setState({ endDate: "" });
                      this.setState({ selectMonth: "" });
                      this.setState({ selectYear: "" });
                      this.setState({ rutUser: "" });
                      this.setState({ cuponPago: "" });

                      this.refs.startDate.setState({ startDate: "" });
                      this.refs.finishDate.setState({ startDate: "" });
                      this.refs.selectMonth.setState({ selectedOption: null });
                      this.refs.selectYear.setState({ selectedOption: null });
                    }}
                  >
                    Limpiar
                </Buttons.Clear>
                </ActionForm>
              </FormBlock>
            </form>
          ) : ''}

          {this.state.data.length > 0 ? (
            <Fragment>
              <TableTitle>Resultado de Búsqueda</TableTitle>
            </Fragment>
          ) : (
            ""
          )}
          {this.state.data.length > 0 ?
            (
              <Fragment>
                <ReactTable
                  PaginationComponent={Pagination}
                  data={this.state.data}
                  columns={[
                    {
                      Header: "Nombre",
                      accessor: "nombreCompleto",
                      width: WIDTH_CELL_STATUS_NAME,
                      style: { whiteSpace: "unset", paddingTop: 15 },
                    },
                    {
                      Header: "Rut",
                      accessor: "rut",
                      width: WIDTH_CELL_BUSINESSID,
                      style: { whiteSpace: "unset", paddingTop: 15 },
                    },
                    {
                      Header: "Email",
                      accessor: "email",
                      width: WIDTH_CELL_CREATE_AT,
                      style: { whiteSpace: "unset", paddingTop: 15 },
                    },
                    {
                      Header: "Fecha Facturación",
                      accessor: "fechaFacturacion",
                      style: { whiteSpace: "unset", paddingTop: 15 },
                    },
                    {
                      Header: "Monto total",
                      accessor: "montoTotal",
                      style: { whiteSpace: "unset", paddingTop: 15 },
                    }
                    , {
                      Header: "Descargar",
                      style: { whiteSpace: "unset", paddingTop: 16, paddingBottom: 14 },
                      width: WIDTH_CELL_ACTION,
                      sortable: false,
                      filterable: false,
                      Cell: ({ row }) => (
                        // <Link to={{ pathname: `${API_URL_BACKEND}/genpdf/${row._original.id}` }} target="_blank">
                        //   <BtnAction> PDF </BtnAction>
                        // </Link>
                        <BtnAction onClick={ this.handleClickDownload.bind(row,row)}> PDF </BtnAction>
                      ),
                    },
                    {
                      Header: "Enviar correo",
                      style: { whiteSpace: "unset", paddingTop: 16, paddingBottom: 14 },
                      width: WIDTH_CELL_ACTION,
                      sortable: false,
                      filterable: false,
                      Cell: ({ row }) => (
                        <BtnAction onClick={ this.handleClickOpen.bind(row,row)}> Email </BtnAction>
                      ),
                    }
                  ]}
                  previousText={"Anterior"}
                  nextText={"Siguiente"}
                  resizable={false}
                  defaultPageSize={
                    this.state.data.length >= 10 ? 10 : this.state.data.length
                  }
                  noDataText={"No hay registros"}
                  style={{ textAlign: "center" }}
                  className="-striped -highlight"
                  resizable={true}
                />
              </Fragment>
            ) : null}
          <Modal
            show={this.state.isOpen}
            onClose={() => {
              this.state.isClosable
                ? this.setState({
                  isOpen: !this.state.isOpen,
                })
                : console.warn("worker on something...");
            }}
          >
            <Template name={this.state.modalChildren} text={this.state.text} image={this.state.image} />
          </Modal>
          <div >

            <Dialog open={this.state.open} onClose={this.handleClose} fullWidth={this.state.fullWidth} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Ingresar correos </DialogTitle>
              <DialogContent>
              
                <TextField
                  autoComplete={false}
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Correo titular."
                  type="text"
                  value={this.state.textEmailTitular}
                  onBlur={ (e) => {
                    if(e.target.value === ''){
                      this.setState({ sTextEmailTitular: false })
                    }
                  } }
                  onChange={(ev) => {
                    !emailValidator.validate(ev.target.value)  ? 
                      this.setState({ sTextEmailTitular: true, mTextEmailTitular: 'Correo ingresado no es válido' }) : 
                      this.setState({ sTextEmailTitular: false });
                      this.setState({ textEmailTitular: ev.target.value });
                  }}
                  fullWidth
                />
                <InputError
                  isShow={this.state.sTextEmailTitular}
                  value={this.state.mTextEmailTitular}
                ></InputError>
                <TextField
                  margin="dense"
                  id="name"
                  label="Copias de correo, presione 'Enter' para agregar los CC"
                  type="text"
                  value={this.state.textEmailCopies}
                  onKeyPress={(ev) => {
                    if (ev.key === 'Enter') {
                      ev.preventDefault();
                      let chipDataArray = this.state.chipData;
                      if (emailValidator.validate(this.state.textEmailCopies)) {
                        let exist = chipDataArray.some(obj => obj.label.toUpperCase() === this.state.textEmailCopies.toUpperCase());

                        if (!exist) {
                          let emailCopy = {
                            key: this.uuidv4(),
                            label: this.state.textEmailCopies
                          }
                          chipDataArray.push(emailCopy);
                        }
                        this.setState({ textEmailCopies: '' });                        
                      }

                      this.setState({
                        chipData: chipDataArray
                      });
                    }
                  }}
                  onBlur={(e) => {
                    if (e.target.value === '') {
                      this.setState({ stextEmailCopies: false });
                    }
                  }}
                  onChange={(event) => {
                    !emailValidator.validate(event.target.value)  ? 
                    this.setState({ stextEmailCopies: true, mtextEmailCopies: 'Correo ingresado no es válido' }) : 
                    this.setState({ stextEmailCopies: false });

                    this.setState({ textEmailCopies: event.target.value });
                  }}
                  fullWidth
                />
                <InputError
                  isShow={this.state.stextEmailCopies}
                  value={this.state.mtextEmailCopies}
                ></InputError>
                <div >

                </div>
                <Paper component="ul" style={{
                  display: 'flex',
                  justifyContent: 'start',
                  flexWrap: 'wrap',
                  listStyle: 'none',
                  padding: '0.5',
                  margin: 0
                }} >
                  {this.state.chipData.map((data) => {
                    return (
                      <li key={data.key}>
                        <Chip
                          id={data.key}
                          key={data.key}
                          label={data.label}
                          onDelete={this.handleDelete.bind(data, data)}
                          style={{ margin: '0.5' }}

                        />
                      </li>
                    );
                  })}
                </Paper>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancelar
          </Button>
                <Button onClick={this.sendEmails} color="primary">
                  Enviar
          </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Fragment>
      );
    } else {
      this.props.history.push('/home');
      return "";
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ data: [] });
    this.validationRequest();
  };

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  handleDelete = async  (data, ev) => {
    const dataChip = await  this.removeItemFromArr(this.state.chipData, data);
    this.setState({ chipData: dataChip });
  }

 async removeItemFromArr( arr, item ) {
    return arr.filter( function( e ) {
      return e !== item;
    });
  };

  async refreshToken() {
    try {
      this.setState({
        isOpen: true,
        modalChildren: "loader",
        isClosable: true,
      });
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const { refreshToken } = cognitoUser.getSignInUserSession();
      cognitoUser.refreshSession(refreshToken, (err, session) => {
        const { accessToken } = session;
        localStorage.setItem("token", accessToken.jwtToken);
      });
    } catch (e) {
      this.setState({
        isOpen: true,
        modalChildren: "login-invalid",
        isClosable: true,
        text: e,
        image: '/images/errorService.png'
      });
      localStorage.clear();
      window.location = '/';
    }
  };

  handleClickOpen = (row,ev) => {  
    this.setState({ infoRow: row });
    this.setState({ open: true });
    this.setState({ textEmailTitular: row._original.email })
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  getStatusPay = () => {
    const requestData = {
      rut: this.state.rutUser,
      mesFacturacion: this.state.selectMonth,
      anioFacturacion: this.state.selectYear,
      cuponPago: this.state.cuponPago,
      fechaInicio: this.state.startDate === "" ? "" : moment(this.state.startDate).format('DD-MM-YYYY'),
      fechaFin: this.state.endDate === "" ? "" : moment(this.state.endDate).format('DD-MM-YYYY')
    }

    fetch(`${API_URL_BACKEND}/consultarEstadosPago`, {
      method: 'POST',
      body: JSON.stringify(requestData),
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(result => {
      return result.status != 204 ? result.json() : {};
    })
    .then((response) => {

      if (response.code === 200 && response.hasOwnProperty('data')) {
        this.setState({
          data: response.data
        });

        this.setState({
          isOpen: false,
          modalChildren: "personalized",
          isClosable: true
        });
      } else {
        this.setState({
          isOpen: true,
          modalChildren: "personalized",
          isClosable: true,
          text: 'No se encontraron datos',
          image: '/images/lup.png'
        });
      }
    })
    .catch((e) => {
      this.setState({
        isOpen: true,
        modalChildren: "personalized",
        isClosable: true,
        text: e,
        image: '/images/errorService.png'
      });
    });
  };

  async validationRequest() {
    if ((this.state.rutUser === "" && this.state.cuponPago === "") || this.state.sRutUser === true) {
      this.setState({
        isOpen: true,
        modalChildren: "personalized",
        isClosable: true,
        text: 'Para realizar la consulta debe ingresar al menos el Rut válido o Cupón de pago',
        image: '/images/errorService.png'
      });
    } else if ((this.state.selectMonth !== "" && this.state.selectYear === "") || (this.state.selectYear !== "" && this.state.selectMonth === "")) {
      this.setState({
        isOpen: true,
        modalChildren: "personalized",
        isClosable: true,
        text: 'Debe seleccionar un período de facturación válido, Mes y Año',
        image: '/images/errorService.png'
      });
    } else if ((this.state.startDate !== "" && this.state.endDate === "") || (this.state.endDate !== "" && this.state.startDate === "")) {
      this.setState({
        isOpen: true,
        modalChildren: "personalized",
        isClosable: true,
        text: 'Debe seleccionar un rango de fechas válido',
        image: '/images/errorService.png'
      });
    } else {
      await this.refreshToken();
      this.getStatusPay()
    }
  }

  onChangeRut = (e) => {
    validate(clean(e.value)) ? this.setState({
      sRutUser: false
    }) : this.setState({
      mRutUser: 'Rut inválido',
      sRutUser: true
    })



    this.setState({
      rutUser: format(e.value),
    });
  };

  onBlurRut = (e) => {
    if(e.value === '-'){
      this.setState({ rutUser: '', sRutUser: false });
    }
  }

  onChangeCuponPago = (e) => {
    this.setState({
      cuponPago: e.value,
    });
  };

  onChangeBoxMonth = (e) => {
    this.setState({
      selectMonth: e.value,
    });
  };

  onChangeBoxYear = (e) => {
    this.setState({
      selectYear: e.value
    })
  };

  onChangeStartDate = (e) => {
    this.setState({
      startDate: e,
    });

    this.refs.finishDate.setState({
      maxDate: new Date(getFinishMaxDate(e, 4)),
      minDate: e,
      startDate: "",
    });
  };

  onChangeEndDate = (e) => {
    this.setState({
      endDate: e,
    });
  };

  onRowClicks = (state, rowInfo, instance) => {
    return {
      onClick: () => {
        this.setState({
          visible: false,
          idOrder: rowInfo.row._original.businessId,
          engineId: rowInfo.row._original.idInstance
        });
      }
    }
  }

  handleClickDownload = (row,ev)  => {

    this.setState({
      open: false,
      isOpen: true,
      modalChildren: "loader",
      isClosable: true,   
   });
  fetch(`${API_URL_BACKEND}/genpdf/${row._original.id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/pdf',
    },
  })
  .then((response) => response.status === 500 ? undefined :  response.blob())
  .then((blob) => {

    if(blob === undefined){
      this.setState({
        isOpen: true,
        modalChildren: "personalized",
        isClosable: true,
        text: 'Ha ocurrido un error al generar pdf, por favor reintentar',
        image: '/images/errorService.png'
      });
      return;
    }
    // Create blob link to download
    const url = window.URL.createObjectURL(
      new Blob([blob]),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `EstadoPago.pdf`,
    );

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    this.setState({
      open: false,
      isOpen: false,
      modalChildren: "loader",
      isClosable: true,   
   });
  }).catch(() => {
    this.setState({
      isOpen: true,
      modalChildren: "personalized",
      isClosable: true,
      text: 'Ha ocurrido un error al generar pdf, por favor reintentar',
      image: '/images/errorService.png'
    });
  });
  }

  sendEmails = async() => {
    if(this.state.sTextEmailTitular === false && this.state.textEmailTitular !== ''){
      this.setState({
        open: false,
        isOpen: true,
        modalChildren: "loader",
        isClosable: true,   
     });

     const requestData = {
       emailTitular: this.state.textEmailTitular,
       emailCopies: await this.getFormatEmail(),
       idStatusPay: this.state.infoRow._original.id
     }

     await this.refreshToken();
     
      fetch(`${API_URL_BACKEND}/enviarCorreo`, {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: {
          "Content-Type": "application/json",
        }
       })
       .then(result => {
         return result.json();
       })
       .then((response) => {
         if (response.code === 200) {
           
           this.setState({
             isOpen: true,
             modalChildren: "success",
             isClosable: true
           });

           this.setState({
             textEmailTitular: "",
             textEmailCopies: [],
             chipData: []
           });
         } else {
           this.setState({
             isOpen: true,
             modalChildren: "personalized",
             isClosable: true,
             text: response.description,
             image: '/images/errorService.png'
           });
         }
       })
       .catch((e) => {
         this.setState({
           isOpen: true,
           modalChildren: "personalized",
           isClosable: true,
           text: e,
           image: '/images/errorService.png'
         });
       });
    }else{
      this.setState({ sTextEmailTitular: true });
    }
  }

  getFormatEmail = () => {
      const chipData = this.state.chipData;
      let arrayEmailFinish = [];
      chipData.map((email) => {
          arrayEmailFinish.push(email.label)
      });

      return arrayEmailFinish;
  }

}

export default EstadoPagoComponent;
